import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import {
  DEFAULT_PREFS,
  loadStoredAppearance,
  type AppearancePrefs,
} from '@/lib/appearance';

// Hydrated synchronously from localStorage at module load so the first render
// already has the user's theme — no flash of the default. `main.tsx` also does
// a one-shot apply before React mounts.
const initialState: AppearancePrefs = loadStoredAppearance();

const appearanceSlice = createSlice({
  name: 'appearance',
  initialState,
  reducers: {
    setPreset(state, action: PayloadAction<string>) {
      state.presetId = action.payload;
    },
    setCustomColors(state, action: PayloadAction<{ bg?: string; accent?: string }>) {
      state.presetId = 'custom';
      if (action.payload.bg !== undefined) state.customBg = action.payload.bg;
      if (action.payload.accent !== undefined) state.customAccent = action.payload.accent;
    },
    resetAppearance() {
      return { ...DEFAULT_PREFS };
    },
  },
});

export const { setPreset, setCustomColors, resetAppearance } = appearanceSlice.actions;
export default appearanceSlice.reducer;
